export default "__VITE_ASSET__BndYC2jd__"